import { useFetch } from './useFetch';
import { AccordionBlockData } from '../types/optimizely/blocks/accordionBlockHP';


export const useAccordionBlockData = (
	blockId: string,
): AccordionBlockData | null => {
	const { data } = useFetch<AccordionBlockData>(blockId);
	if (data) {
		return data
	} else {
		return null;
	}
};
